import styled from "styled-components";

export const CardWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  @media (min-width: 1025px) {
    justify-content: flex-start;
    padding: ${({ theme }) => theme.CONSTANTS.XH * 1}px 0;
  }
`;

export const ContentWrapper = styled.div`
  width: 85%;

  @media (min-width: 1025px) {
    width: 80%;
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: ${({ theme }) => theme.CONSTANTS.XH * 1.5}px 0;
  width: 100%;
`;

export const Title = styled.h3`
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 24}px;
  font-weight: 600;
  color: ${({ theme }) => theme.THEME.white};
  font-family: "Sora", sans-serif;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 7}px;
  }
`;

export const ToggleIcon = styled.span`
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 26}px;
  color: ${({ theme }) => theme.THEME.white};
  font-weight: 400;
  user-select: none;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 8}px;
  }
`;

export const Description = styled.p`
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 24}px;
  color: ${({ theme }) => theme.THEME.white};
  font-family: "Inter", sans-serif;
  margin-top: ${({ theme }) => theme.CONSTANTS.XH}px;
  line-height: 1.6;
  text-align: start;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6}px;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    ${({ theme }) => theme.THEME.neonBlue} 90%,
    transparent 100%
  );
`;
